import { render, staticRenderFns } from "./QuoteBlock.vue?vue&type=template&id=3f4d4fc5&"
import script from "./QuoteBlock.vue?vue&type=script&lang=js&"
export * from "./QuoteBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports